import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'sbPermissionTranslate',
  pure: true,
  standalone: false,
})
export class PermissionTranslator implements PipeTransform {
  friendlyNames: Record<string, string> = {
    addon_strongbytes_playout_export: marker('permission.addon_strongbytes_playout_export'),
    admin: marker('permission.admin'),
    ai_access: marker('permission.ai_access'),
    area_category_create: marker('permission.area_category_create'),
    area_category_delete: marker('permission.area_category_delete'),
    area_category_edit: marker('permission.area_category_edit'),
    area_category_list: marker('permission.area_category_list'),
    area_category_show: marker('permission.area_category_show'),
    area_create: marker('permission.area_create'),
    area_delete: marker('permission.area_delete'),
    area_edit: marker('permission.area_edit'),
    area_list: marker('permission.area_list'),
    area_show: marker('permission.area_show'),
    asset_category_create: marker('permission.asset_category_create'),
    asset_category_delete: marker('permission.asset_category_delete'),
    asset_category_edit: marker('permission.asset_category_edit'),
    asset_category_list: marker('permission.asset_category_list'),
    asset_category_show: marker('permission.asset_category_show'),
    asset_create: marker('permission.asset_create'),
    asset_delete: marker('permission.asset_delete'),
    asset_edit: marker('permission.asset_edit'),
    asset_edit_files: marker('permission.asset_edit_files'),
    asset_export: marker('permission.asset_export'),
    asset_list: marker('permission.asset_list'),
    asset_repository_create: marker('permission.asset_repository_create'),
    asset_repository_delete: marker('permission.asset_repository_delete'),
    asset_repository_edit: marker('permission.asset_repository_edit'),
    asset_repository_edit_assets: marker('permission.asset_repository_edit_assets'),
    asset_repository_export: marker('permission.asset_repository_export'),
    asset_repository_list: marker('permission.asset_repository_list'),
    asset_repository_show: marker('permission.asset_repository_show'),
    asset_show: marker('permission.asset_show'),
    attachment_admin: marker('permission.attachment_admin'),
    attachment_attach: marker('permission.attachment_attach'),
    attachment_attach_to_area: marker('permission.attachment_attach_to_area'),
    attachment_attach_to_campaign: marker('permission.attachment_attach_to_campaign'),
    attachment_attach_to_channel: marker('permission.attachment_attach_to_channel'),
    attachment_attach_to_company: marker('permission.attachment_attach_to_company'),
    attachment_attach_to_deal: marker('permission.attachment_attach_to_deal'),
    attachment_attach_to_device: marker('permission.attachment_attach_to_device'),
    attachment_attach_to_discussion_post: marker('permission.attachment_attach_to_discussion_post'),
    attachment_attach_to_discussion_topic: marker('permission.attachment_attach_to_discussion_topic'),
    attachment_attach_to_location: marker('permission.attachment_attach_to_location'),
    attachment_attach_to_player_hardware: marker('permission.attachment_attach_to_player_hardware'),
    attachment_attach_to_player_software: marker('permission.attachment_attach_to_player_software'),
    attachment_attach_to_product: marker('permission.attachment_attach_to_product'),
    attachment_attach_to_screen_hardware: marker('permission.attachment_attach_to_screen_hardware'),
    attachment_attach_to_ssp: marker('permission.attachment_attach_to_ssp'),
    attachment_attach_to_ssp_contract: marker('permission.attachment_attach_to_ssp_contract'),
    attachment_attach_to_visitor_tracker: marker('permission.attachment_attach_to_visitor_tracker'),
    attachment_attaching: marker('permission.attachment_attaching'),
    attachment_create: marker('permission.attachment_create'),
    attachment_delete: marker('permission.attachment_delete'),
    attachment_detach: marker('permission.attachment_detach'),
    attachment_detach_from_area: marker('permission.attachment_detach_from_area'),
    attachment_detach_from_campaign: marker('permission.attachment_detach_from_campaign'),
    attachment_detach_from_channel: marker('permission.attachment_detach_from_channel'),
    attachment_detach_from_company: marker('permission.attachment_detach_from_company'),
    attachment_detach_from_deal: marker('permission.attachment_detach_from_deal'),
    attachment_detach_from_device: marker('permission.attachment_detach_from_device'),
    attachment_detach_from_discussion_post: marker('permission.attachment_detach_from_discussion_post'),
    attachment_detach_from_discussion_topic: marker('permission.attachment_detach_from_discussion_topic'),
    attachment_detach_from_location: marker('permission.attachment_detach_from_location'),
    attachment_detach_from_player_hardware: marker('permission.attachment_detach_from_player_hardware'),
    attachment_detach_from_player_software: marker('permission.attachment_detach_from_player_software'),
    attachment_detach_from_product: marker('permission.attachment_detach_from_product'),
    attachment_detach_from_screen_hardware: marker('permission.attachment_detach_from_screen_hardware'),
    attachment_detach_from_ssp: marker('permission.attachment_detach_from_ssp'),
    attachment_detach_from_ssp_contract: marker('permission.attachment_detach_from_ssp_contract'),
    attachment_detach_from_visitor_tracker: marker('permission.attachment_detach_from_visitor_tracker'),
    attachment_edit: marker('permission.attachment_edit'),
    attachment_folder_create: marker('permission.attachment_folder_create'),
    attachment_folder_delete: marker('permission.attachment_folder_delete'),
    attachment_folder_edit: marker('permission.attachment_folder_edit'),
    attachment_folder_list: marker('permission.attachment_folder_list'),
    attachment_folder_show: marker('permission.attachment_folder_show'),
    attachment_list: marker('permission.attachment_list'),
    attachment_show: marker('permission.attachment_show'),
    booking_list: marker('permission.booking_list'),
    booking_show: marker('permission.booking_show'),
    budget_create: marker('permission.budget_create'),
    budget_delete: marker('permission.budget_delete'),
    budget_edit: marker('permission.budget_edit'),
    budget_list: marker('permission.budget_list'),
    budget_planning_create: marker('permission.budget_planning_create'),
    budget_planning_edit: marker('permission.budget_planning_edit'),
    budget_show: marker('permission.budget_show'),
    ca: marker('permission.ca'),
    ca_am: marker('permission.ca_am'),
    ca_md: marker('permission.ca_md'),
    calendar_category_create: marker('permission.calendar_category_create'),
    calendar_category_delete: marker('permission.calendar_category_delete'),
    calendar_category_edit: marker('permission.calendar_category_edit'),
    calendar_category_list: marker('permission.calendar_category_list'),
    calendar_category_show: marker('permission.calendar_category_show'),
    calendar_entry_attributes_edit: marker('permission.calendar_entry_attributes_edit'),
    calendar_entry_attributes_show: marker('permission.calendar_entry_attributes_show'),
    calendar_entry_category_create: marker('permission.calendar_entry_category_create'),
    calendar_entry_category_delete: marker('permission.calendar_entry_category_delete'),
    calendar_entry_category_edit: marker('permission.calendar_entry_category_edit'),
    calendar_entry_category_list: marker('permission.calendar_entry_category_list'),
    calendar_entry_category_show: marker('permission.calendar_entry_category_show'),
    calendar_entry_meta_data_type_create: marker('permission.calendar_entry_meta_data_type_create'),
    calendar_entry_meta_data_type_delete: marker('permission.calendar_entry_meta_data_type_delete'),
    calendar_entry_meta_data_type_edit: marker('permission.calendar_entry_meta_data_type_edit'),
    calendar_entry_meta_data_type_list: marker('permission.calendar_entry_meta_data_type_list'),
    calendar_entry_meta_data_type_show: marker('permission.calendar_entry_meta_data_type_show'),
    campaign_change_order: marker('permission.campaign_change_order'),
    campaign_create: marker('permission.campaign_create'),
    campaign_delete: marker('permission.campaign_delete'),
    campaign_edit: marker('permission.campaign_edit'),
    campaign_level_create: marker('permission.campaign_level_create'),
    campaign_level_delete: marker('permission.campaign_level_delete'),
    campaign_level_edit: marker('permission.campaign_level_edit'),
    campaign_level_list: marker('permission.campaign_level_list'),
    campaign_level_show: marker('permission.campaign_level_show'),
    campaign_list: marker('permission.campaign_list'),
    campaign_report: marker('permission.campaign_report'),
    campaign_show: marker('permission.campaign_show'),
    campaign_type_create: marker('permission.campaign_type_create'),
    campaign_type_delete: marker('permission.campaign_type_delete'),
    campaign_type_edit: marker('permission.campaign_type_edit'),
    campaign_type_list: marker('permission.campaign_type_list'),
    campaign_type_show: marker('permission.campaign_type_show'),
    channel_change_order: marker('permission.channel_change_order'),
    channel_create: marker('permission.channel_create'),
    channel_delete: marker('permission.channel_delete'),
    channel_edit: marker('permission.channel_edit'),
    channel_list: marker('permission.channel_list'),
    channel_lock: marker('permission.channel_lock'),
    channel_show: marker('permission.channel_show'),
    client_admin: marker('permission.client_admin'),
    client_setting_delete: marker('permission.client_setting_delete'),
    client_setting_edit: marker('permission.client_setting_edit'),
    client_setting_list: marker('permission.client_setting_list'),
    client_setting_show: marker('permission.client_setting_show'),
    client_user_block: marker('permission.client_user_block'),
    client_user_create: marker('permission.client_user_create'),
    client_user_delete: marker('permission.client_user_delete'),
    client_user_edit: marker('permission.client_user_edit'),
    client_user_impersonate: marker('permission.client_user_impersonate'),
    client_user_list: marker('permission.client_user_list'),
    client_user_unblock: marker('permission.client_user_unblock'),
    color_definition_create: marker('permission.color_definition_create'),
    color_definition_delete: marker('permission.color_definition_delete'),
    color_definition_edit: marker('permission.color_definition_edit'),
    color_definition_list: marker('permission.color_definition_list'),
    color_definition_show: marker('permission.color_definition_show'),
    company_attribute_datatype_create: marker('permission.company_attribute_datatype_create'),
    company_attribute_datatype_delete: marker('permission.company_attribute_datatype_delete'),
    company_attribute_datatype_edit: marker('permission.company_attribute_datatype_edit'),
    company_attribute_datatype_list: marker('permission.company_attribute_datatype_list'),
    company_attribute_datatype_show: marker('permission.company_attribute_datatype_show'),
    company_attributes_edit: marker('permission.company_attributes_edit'),
    company_attributes_show: marker('permission.company_attributes_show'),
    company_create: marker('permission.company_create'),
    company_delete: marker('permission.company_delete'),
    company_edit: marker('permission.company_edit'),
    company_export: marker('permission.company_export'),
    company_list: marker('permission.company_list'),
    company_show: marker('permission.company_show'),
    contact_create: marker('permission.contact_create'),
    contact_delete: marker('permission.contact_delete'),
    contact_edit: marker('permission.contact_edit'),
    contact_list: marker('permission.contact_list'),
    contact_show: marker('permission.contact_show'),
    content_editor: marker('permission.content_editor'),
    content_share_create: marker('permission.content_share_create'),
    content_share_delete: marker('permission.content_share_delete'),
    content_share_edit: marker('permission.content_share_edit'),
    content_share_list: marker('permission.content_share_list'),
    content_share_show: marker('permission.content_share_show'),
    cron_definition_create: marker('permission.cron_definition_create'),
    cron_definition_delete: marker('permission.cron_definition_delete'),
    cron_definition_edit: marker('permission.cron_definition_edit'),
    cron_definition_list: marker('permission.cron_definition_list'),
    cron_definition_show: marker('permission.cron_definition_show'),
    cs: marker('permission.cs'),
    cull_category_create: marker('permission.cull_category_create'),
    cull_category_delete: marker('permission.cull_category_delete'),
    cull_category_edit: marker('permission.cull_category_edit'),
    cull_category_list: marker('permission.cull_category_list'),
    cull_category_show: marker('permission.cull_category_show'),
    cull_client_create: marker('permission.cull_client_create'),
    cull_client_delete: marker('permission.cull_client_delete'),
    cull_client_edit: marker('permission.cull_client_edit'),
    cull_content_create: marker('permission.cull_content_create'),
    cull_content_delete: marker('permission.cull_content_delete'),
    cull_content_edit: marker('permission.cull_content_edit'),
    cull_create: marker('permission.cull_create'),
    cull_delete: marker('permission.cull_delete'),
    cull_edit: marker('permission.cull_edit'),
    cull_geo_create: marker('permission.cull_geo_create'),
    cull_geo_delete: marker('permission.cull_geo_delete'),
    cull_geo_edit: marker('permission.cull_geo_edit'),
    cull_hide: marker('permission.cull_hide'),
    cull_list: marker('permission.cull_list'),
    cull_lock: marker('permission.cull_lock'),
    cull_lock_admin: marker('permission.cull_lock_admin'),
    cull_player_create: marker('permission.cull_player_create'),
    cull_player_delete: marker('permission.cull_player_delete'),
    cull_player_edit: marker('permission.cull_player_edit'),
    cull_show: marker('permission.cull_show'),
    cull_state_space_create: marker('permission.cull_state_space_create'),
    cull_state_space_delete: marker('permission.cull_state_space_delete'),
    cull_state_space_edit: marker('permission.cull_state_space_edit'),
    cull_time_create: marker('permission.cull_time_create'),
    cull_time_delete: marker('permission.cull_time_delete'),
    cull_time_edit: marker('permission.cull_time_edit'),
    deal_create: marker('permission.deal_create'),
    deal_delete: marker('permission.deal_delete'),
    deal_edit: marker('permission.deal_edit'),
    deal_list: marker('permission.deal_list'),
    deal_show: marker('permission.deal_show'),
    device_admin: marker('permission.device_admin'),
    device_attribute_datatype_create: marker('permission.device_attribute_datatype_create'),
    device_attribute_datatype_delete: marker('permission.device_attribute_datatype_delete'),
    device_attribute_datatype_edit: marker('permission.device_attribute_datatype_edit'),
    device_attribute_datatype_list: marker('permission.device_attribute_datatype_list'),
    device_attribute_datatype_show: marker('permission.device_attribute_datatype_show'),
    device_attributes_edit: marker('permission.device_attributes_edit'),
    device_attributes_show: marker('permission.device_attributes_show'),
    device_clear_local_data: marker('permission.device_clear_local_data'),
    device_clear_local_settings: marker('permission.device_clear_local_settings'),
    device_create: marker('permission.device_create'),
    device_delete: marker('permission.device_delete'),
    device_execute_remote_command: marker('permission.device_execute_remote_command'),
    device_exit_player: marker('permission.device_exit_player'),
    device_export: marker('permission.device_export'),
    device_export_log: marker('permission.device_export_log'),
    device_export_offline_playlist: marker('permission.device_export_offline_playlist'),
    device_export_playout: marker('permission.device_export_playout'),
    device_list: marker('permission.device_list'),
    device_location_edit: marker('permission.device_location_edit'),
    device_location_show: marker('permission.device_location_show'),
    device_log: marker('permission.device_log'),
    device_mass_action: marker('permission.device_mass_action'),
    device_mass_edit: marker('permission.device_mass_edit'),
    device_pair: marker('permission.device_pair'),
    device_playlist_cache_delete: marker('permission.device_playlist_cache_delete'),
    device_pool_edit: marker('permission.device_pool_edit'),
    device_pool_show: marker('permission.device_pool_show'),
    device_properties_edit: marker('permission.device_properties_edit'),
    device_properties_show: marker('permission.device_properties_show'),
    device_reboot: marker('permission.device_reboot'),
    device_repair: marker('permission.device_repair'),
    device_show: marker('permission.device_show'),
    device_show_calibration_image: marker('permission.device_show_calibration_image'),
    device_unpair: marker('permission.device_unpair'),
    discussion_create: marker('permission.discussion_create'),
    discussion_list: marker('permission.discussion_list'),
    discussion_moderate: marker('permission.discussion_moderate'),
    discussion_participate: marker('permission.discussion_participate'),
    dm: marker('permission.dm'),
    dm_geo: marker('permission.dm_geo'),
    ds: marker('permission.ds'),
    ds_cm: marker('permission.ds_cm'),
    ds_cm_reporting: marker('permission.ds_cm_reporting'),
    ds_rm: marker('permission.ds_rm'),
    location_attribute_datatype_create: marker('permission.location_attribute_datatype_create'),
    location_attribute_datatype_delete: marker('permission.location_attribute_datatype_delete'),
    location_attribute_datatype_edit: marker('permission.location_attribute_datatype_edit'),
    location_attribute_datatype_list: marker('permission.location_attribute_datatype_list'),
    location_attribute_datatype_show: marker('permission.location_attribute_datatype_show'),
    location_attributes_edit: marker('permission.location_attributes_edit'),
    location_attributes_show: marker('permission.location_attributes_show'),
    location_create: marker('permission.location_create'),
    location_delete: marker('permission.location_delete'),
    location_devices_show: marker('permission.location_devices_show'),
    location_edit: marker('permission.location_edit'),
    location_export: marker('permission.location_export'),
    location_list: marker('permission.location_list'),
    location_show: marker('permission.location_show'),
    location_type_create: marker('permission.location_type_create'),
    location_type_delete: marker('permission.location_type_delete'),
    location_type_edit: marker('permission.location_type_edit'),
    location_type_list: marker('permission.location_type_list'),
    location_type_show: marker('permission.location_type_show'),
    location_visitor_aggregation: marker('permission.location_visitor_aggregation'),
    medium_create: marker('permission.medium_create'),
    medium_delete: marker('permission.medium_delete'),
    medium_edit: marker('permission.medium_edit'),
    medium_group_add_promoted_products: marker('permission.medium_group_add_promoted_products'),
    medium_group_attribute_datatype_create: marker('permission.medium_group_attribute_datatype_create'),
    medium_group_attribute_datatype_delete: marker('permission.medium_group_attribute_datatype_delete'),
    medium_group_attribute_datatype_edit: marker('permission.medium_group_attribute_datatype_edit'),
    medium_group_attribute_datatype_list: marker('permission.medium_group_attribute_datatype_list'),
    medium_group_attribute_datatype_show: marker('permission.medium_group_attribute_datatype_show'),
    medium_group_attributes_edit: marker('permission.medium_group_attributes_edit'),
    medium_group_attributes_show: marker('permission.medium_group_attributes_show'),
    medium_group_category_create: marker('permission.medium_group_category_create'),
    medium_group_category_delete: marker('permission.medium_group_category_delete'),
    medium_group_category_edit: marker('permission.medium_group_category_edit'),
    medium_group_category_list: marker('permission.medium_group_category_list'),
    medium_group_category_show: marker('permission.medium_group_category_show'),
    medium_group_create: marker('permission.medium_group_create'),
    medium_group_delete: marker('permission.medium_group_delete'),
    medium_group_edit: marker('permission.medium_group_edit'),
    medium_group_list: marker('permission.medium_group_list'),
    medium_group_manage_promoted_products: marker('permission.medium_group_manage_promoted_products'),
    medium_group_remove_promoted_products: marker('permission.medium_group_remove_promoted_products'),
    medium_group_show: marker('permission.medium_group_show'),
    medium_list: marker('permission.medium_list'),
    medium_lock: marker('permission.medium_lock'),
    medium_show: marker('permission.medium_show'),
    medium_transformation_list: marker('permission.medium_transformation_list'),
    medium_transformation_show: marker('permission.medium_transformation_show'),
    medium_upload: marker('permission.medium_upload'),
    mi: marker('permission.mi'),
    mm: marker('permission.mm'),
    network_booking_list: marker('permission.network_booking_list'),
    network_booking_show: marker('permission.network_booking_show'),
    network_price_model_create: marker('permission.network_price_model_create'),
    network_price_model_delete: marker('permission.network_price_model_delete'),
    network_price_model_edit: marker('permission.network_price_model_edit'),
    network_price_model_list: marker('permission.network_price_model_list'),
    network_price_model_show: marker('permission.network_price_model_show'),
    network_share_create: marker('permission.network_share_create'),
    network_share_delete: marker('permission.network_share_delete'),
    network_share_edit: marker('permission.network_share_edit'),
    network_share_list: marker('permission.network_share_list'),
    network_share_show: marker('permission.network_share_show'),
    notification_archive: marker('permission.notification_archive'),
    notification_list: marker('permission.notification_list'),
    notification_read: marker('permission.notification_read'),
    notification_show: marker('permission.notification_show'),
    planning_accept: marker('permission.planning_accept'),
    planning_change_order: marker('permission.planning_change_order'),
    planning_create: marker('permission.planning_create'),
    planning_delete: marker('permission.planning_delete'),
    planning_edit: marker('permission.planning_edit'),
    planning_list: marker('permission.planning_list'),
    planning_show: marker('permission.planning_show'),
    planning_submit: marker('permission.planning_submit'),
    playback_schedule_create: marker('permission.playback_schedule_create'),
    playback_schedule_delete: marker('permission.playback_schedule_delete'),
    playback_schedule_edit: marker('permission.playback_schedule_edit'),
    playback_schedule_list: marker('permission.playback_schedule_list'),
    playback_schedule_show: marker('permission.playback_schedule_show'),
    player_hardware_create: marker('permission.player_hardware_create'),
    player_hardware_delete: marker('permission.player_hardware_delete'),
    player_hardware_edit: marker('permission.player_hardware_edit'),
    player_hardware_list: marker('permission.player_hardware_list'),
    player_hardware_show: marker('permission.player_hardware_show'),
    player_software_create: marker('permission.player_software_create'),
    player_software_delete: marker('permission.player_software_delete'),
    player_software_edit: marker('permission.player_software_edit'),
    player_software_list: marker('permission.player_software_list'),
    player_software_show: marker('permission.player_software_show'),
    pm: marker('permission.pm'),
    pool_change_order: marker('permission.pool_change_order'),
    pool_create: marker('permission.pool_create'),
    pool_delete: marker('permission.pool_delete'),
    pool_edit: marker('permission.pool_edit'),
    pool_list: marker('permission.pool_list'),
    pool_show: marker('permission.pool_show'),
    product_add_to_category: marker('permission.product_add_to_category'),
    product_attribute_datatype_create: marker('permission.product_attribute_datatype_create'),
    product_attribute_datatype_delete: marker('permission.product_attribute_datatype_delete'),
    product_attribute_datatype_edit: marker('permission.product_attribute_datatype_edit'),
    product_attribute_datatype_list: marker('permission.product_attribute_datatype_list'),
    product_attribute_datatype_show: marker('permission.product_attribute_datatype_show'),
    product_attributes_edit: marker('permission.product_attributes_edit'),
    product_attributes_show: marker('permission.product_attributes_show'),
    product_category_create: marker('permission.product_category_create'),
    product_category_delete: marker('permission.product_category_delete'),
    product_category_edit: marker('permission.product_category_edit'),
    product_category_list: marker('permission.product_category_list'),
    product_category_show: marker('permission.product_category_show'),
    product_create: marker('permission.product_create'),
    product_delete: marker('permission.product_delete'),
    product_edit: marker('permission.product_edit'),
    product_list: marker('permission.product_list'),
    product_manage_category: marker('permission.product_manage_category'),
    product_promoting_medium_group_add: marker('permission.product_promoting_medium_group_add'),
    product_promoting_medium_group_manage: marker('permission.product_promoting_medium_group_manage'),
    product_promoting_medium_group_remove: marker('permission.product_promoting_medium_group_remove'),
    product_promoting_medium_group_show: marker('permission.product_promoting_medium_group_show'),
    product_remove_from_category: marker('permission.product_remove_from_category'),
    product_show: marker('permission.product_show'),
    reporting_list: marker('permission.reporting_list'),
    reporting_scheduling_list: marker('permission.reporting_scheduling_list'),
    reporting_setup_create: marker('permission.reporting_setup_create'),
    reporting_setup_delete: marker('permission.reporting_setup_delete'),
    reporting_setup_edit: marker('permission.reporting_setup_edit'),
    reporting_setup_list: marker('permission.reporting_setup_list'),
    reporting_setup_show: marker('permission.reporting_setup_show'),
    reporting_show: marker('permission.reporting_show'),
    reporting_template_create: marker('permission.reporting_template_create'),
    reporting_template_delete: marker('permission.reporting_template_delete'),
    reporting_template_edit: marker('permission.reporting_template_edit'),
    reporting_template_list: marker('permission.reporting_template_list'),
    reporting_template_show: marker('permission.reporting_template_show'),
    reporting_type_list: marker('permission.reporting_type_list'),
    reporting_type_show: marker('permission.reporting_type_show'),
    role_create: marker('permission.role_create'),
    role_delete: marker('permission.role_delete'),
    role_edit: marker('permission.role_edit'),
    role_list: marker('permission.role_list'),
    role_show: marker('permission.role_show'),
    screen_booking_blacklist_create: marker('permission.screen_booking_blacklist_create'),
    screen_booking_blacklist_delete: marker('permission.screen_booking_blacklist_delete'),
    screen_booking_blacklist_list: marker('permission.screen_booking_blacklist_list'),
    screen_hardware_create: marker('permission.screen_hardware_create'),
    screen_hardware_delete: marker('permission.screen_hardware_delete'),
    screen_hardware_edit: marker('permission.screen_hardware_edit'),
    screen_hardware_list: marker('permission.screen_hardware_list'),
    screen_hardware_show: marker('permission.screen_hardware_show'),
    shared_asset_export: marker('permission.shared_asset_export'),
    shared_asset_list: marker('permission.shared_asset_list'),
    shared_asset_repository_export: marker('permission.shared_asset_repository_export'),
    shared_asset_repository_list: marker('permission.shared_asset_repository_list'),
    shared_asset_repository_show: marker('permission.shared_asset_repository_show'),
    shared_asset_show: marker('permission.shared_asset_show'),
    sr: marker('permission.sr'),
    ss: marker('permission.ss'),
    ss_cd: marker('permission.ss_cd'),
    ss_cd_reporting: marker('permission.ss_cd_reporting'),
    ss_fm: marker('permission.ss_fm'),
    ss_fm_reporting: marker('permission.ss_fm_reporting'),
    ss_nm: marker('permission.ss_nm'),
    ss_nm_reporting: marker('permission.ss_nm_reporting'),
    ssp_contract_create: marker('permission.ssp_contract_create'),
    ssp_contract_delete: marker('permission.ssp_contract_delete'),
    ssp_contract_edit: marker('permission.ssp_contract_edit'),
    ssp_contract_list: marker('permission.ssp_contract_list'),
    ssp_contract_show: marker('permission.ssp_contract_show'),
    ssp_list: marker('permission.ssp_list'),
    ssp_show: marker('permission.ssp_show'),
    tag_connect: marker('permission.tag_connect'),
    tag_connection_list: marker('permission.tag_connection_list'),
    tag_create: marker('permission.tag_create'),
    tag_delete: marker('permission.tag_delete'),
    tag_disconnect: marker('permission.tag_disconnect'),
    tag_edit: marker('permission.tag_edit'),
    tag_list: marker('permission.tag_list'),
    tag_show: marker('permission.tag_show'),
    targeting_create: marker('permission.targeting_create'),
    targeting_delete: marker('permission.targeting_delete'),
    targeting_edit: marker('permission.targeting_edit'),
    targeting_list: marker('permission.targeting_list'),
    targeting_planning_create: marker('permission.targeting_planning_create'),
    targeting_planning_edit: marker('permission.targeting_planning_edit'),
    targeting_show: marker('permission.targeting_show'),
    template_data_set_create: marker('permission.template_data_set_create'),
    template_data_set_delete: marker('permission.template_data_set_delete'),
    template_data_set_edit: marker('permission.template_data_set_edit'),
    template_data_set_entry_create: marker('permission.template_data_set_entry_create'),
    template_data_set_entry_delete: marker('permission.template_data_set_entry_delete'),
    template_data_set_entry_edit: marker('permission.template_data_set_entry_edit'),
    template_data_set_entry_list: marker('permission.template_data_set_entry_list'),
    template_data_set_entry_render_medium: marker('permission.template_data_set_entry_render_medium'),
    template_data_set_entry_show: marker('permission.template_data_set_entry_show'),
    template_data_set_list: marker('permission.template_data_set_list'),
    template_data_set_show: marker('permission.template_data_set_show'),
    template_group_create: marker('permission.template_group_create'),
    template_group_delete: marker('permission.template_group_delete'),
    template_group_list: marker('permission.template_group_list'),
    template_group_render_medium: marker('permission.template_group_render_medium'),
    template_group_show: marker('permission.template_group_show'),
    template_screen_entry_create: marker('permission.template_screen_entry_create'),
    template_screen_entry_delete: marker('permission.template_screen_entry_delete'),
    template_screen_entry_edit: marker('permission.template_screen_entry_edit'),
    template_screen_entry_list: marker('permission.template_screen_entry_list'),
    template_screen_entry_render_medium: marker('permission.template_screen_entry_render_medium'),
    template_screen_entry_show: marker('permission.template_screen_entry_show'),
    template_source_create: marker('permission.template_source_create'),
    template_source_delete: marker('permission.template_source_delete'),
    template_source_entry_create: marker('permission.template_source_entry_create'),
    template_source_entry_delete: marker('permission.template_source_entry_delete'),
    template_source_entry_edit: marker('permission.template_source_entry_edit'),
    template_source_entry_list: marker('permission.template_source_entry_list'),
    template_source_entry_render_medium: marker('permission.template_source_entry_render_medium'),
    template_source_entry_show: marker('permission.template_source_entry_show'),
    template_source_entry_subscription_create: marker('permission.template_source_entry_subscription_create'),
    template_source_entry_subscription_delete: marker('permission.template_source_entry_subscription_delete'),
    template_source_entry_subscription_edit: marker('permission.template_source_entry_subscription_edit'),
    template_source_entry_subscription_list: marker('permission.template_source_entry_subscription_list'),
    template_source_list: marker('permission.template_source_list'),
    template_source_show: marker('permission.template_source_show'),
    template_store_create: marker('permission.template_store_create'),
    template_store_data_create: marker('permission.template_store_data_create'),
    template_store_data_delete: marker('permission.template_store_data_delete'),
    template_store_data_edit: marker('permission.template_store_data_edit'),
    template_store_data_list: marker('permission.template_store_data_list'),
    template_store_data_show: marker('permission.template_store_data_show'),
    template_store_delete: marker('permission.template_store_delete'),
    template_store_edit: marker('permission.template_store_edit'),
    template_store_list: marker('permission.template_store_list'),
    template_store_show: marker('permission.template_store_show'),
    time_range_create: marker('permission.time_range_create'),
    time_range_delete: marker('permission.time_range_delete'),
    time_range_edit: marker('permission.time_range_edit'),
    time_range_list: marker('permission.time_range_list'),
    time_range_show: marker('permission.time_range_show'),
    user_register: marker('permission.user_register'),
    verification_list: marker('permission.verification_list'),
    verification_reject: marker('permission.verification_reject'),
    verification_show: marker('permission.verification_show'),
    verification_verify: marker('permission.verification_verify'),
    visitor_audience_translation_create: marker('permission.visitor_audience_translation_create'),
    visitor_audience_translation_delete: marker('permission.visitor_audience_translation_delete'),
    visitor_audience_translation_edit: marker('permission.visitor_audience_translation_edit'),
    visitor_audience_translation_list: marker('permission.visitor_audience_translation_list'),
    visitor_audience_translation_show: marker('permission.visitor_audience_translation_show'),
    visitor_diurnal_cycle_create: marker('permission.visitor_diurnal_cycle_create'),
    visitor_diurnal_cycle_delete: marker('permission.visitor_diurnal_cycle_delete'),
    visitor_diurnal_cycle_edit: marker('permission.visitor_diurnal_cycle_edit'),
    visitor_diurnal_cycle_list: marker('permission.visitor_diurnal_cycle_list'),
    visitor_diurnal_cycle_show: marker('permission.visitor_diurnal_cycle_show'),
    visitor_tracker_create: marker('permission.visitor_tracker_create'),
    visitor_tracker_delete: marker('permission.visitor_tracker_delete'),
    visitor_tracker_edit: marker('permission.visitor_tracker_edit'),
    visitor_tracker_export: marker('permission.visitor_tracker_export'),
    visitor_tracker_list: marker('permission.visitor_tracker_list'),
    visitor_tracker_screen_assignment_list: marker('permission.visitor_tracker_screen_assignment_list'),
    visitor_tracker_screen_assignment_modify: marker('permission.visitor_tracker_screen_assignment_modify'),
    visitor_tracker_screen_assignment_show: marker('permission.visitor_tracker_screen_assignment_show'),
    visitor_tracker_show: marker('permission.visitor_tracker_show'),
    visitor_tracker_visitor_aggregation: marker('permission.visitor_tracker_visitor_aggregation'),
    weekly_schedule_create: marker('permission.weekly_schedule_create'),
    weekly_schedule_delete: marker('permission.weekly_schedule_delete'),
    weekly_schedule_edit: marker('permission.weekly_schedule_edit'),
    weekly_schedule_list: marker('permission.weekly_schedule_list'),
    weekly_schedule_show: marker('permission.weekly_schedule_show'),
  };

  constructor(public translate: TranslateService) {}
  transform(permission: any) {
    if (permission) {
      let translation = permission;
      try {
        translation = this.translate.instant(this.friendlyNames[permission]);
      } catch (e) {}
      return translation;
    } else {
      return null;
    }
  }
}
